import { getAwsCredentials } from "src/authentication/cognito";
const AWS = require("aws-sdk");

export const getTaskDetails = async (TABLE_NAME, KEY, VALUE) => {
    console.log(`Reading resources`);
    console.log(VALUE)
    await getAwsCredentials();


    const docClient = new AWS.DynamoDB.DocumentClient({ region: 'us-east-1' ,
        accessKey: AWS.config.credentials.accessKeyId,
        secretKey: AWS.config.credentials.secretAccessKey,
        sessionToken: AWS.config.credentials.sessionToken,
    });


    let queryResults = []
    let params = {
        TableName: TABLE_NAME,
        KeyConditionExpression: `${KEY} = :id`,
        ExpressionAttributeValues: {
            ':id': VALUE
        }
    }

    let params_scan = {
        TableName: TABLE_NAME
    }

    try {
          let data;
          if(TABLE_NAME == "_SupportedTasksDetails"){
              data = await docClient.scan(params_scan).promise();
          } else{
              data = await docClient.query(params).promise();
          }
          console.log(data)
          queryResults = [...data.Items];
    } catch (err) {
        console.log(`Error occurred while fetching entity data `, err);
        throw err;
    }


    return queryResults;
}





